/* TODO: t() */
import React, { Component, Fragment } from 'react';
import { View, StyleSheet } from 'react-native';

import { themeColors } from './Constants';
import Separator from './Separator';
import Text from './Text';

type HeaderProps = {
  title?: string;
  showSeparator?: boolean;
  isVendor?: boolean;
  children?: React.ReactNode;
  style?: StyleSet;
};

type Props = {
  isVendor?: boolean;
  children?: React.ReactNode;
  style?: StyleSet;
};

let styles = StyleSheet.create({
  root: {
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: themeColors.grey,
    borderRadius: 5,
    backgroundColor: themeColors.white,
    padding: 20,
  },
  vendorRoot: {
    borderRadius: 2,
    shadowColor: themeColors.black,
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.4,
    shadowRadius: 3,
    padding: 30,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 10,
  },
  headerText: {
    fontSize: 20,
  },
  vendorText: {
    color: '#909992',
    fontWeight: '600',
  },
  separator: {
    marginBottom: 10,
  },
});

function Header({
  children,
  title,
  showSeparator = true,
  isVendor,
  style,
}: HeaderProps) {
  return (
    <Fragment>
      <View style={[styles.header, style]}>
        {title && (
          <Text style={[styles.headerText, isVendor && styles.vendorText]}>
            {title}
          </Text>
        )}
        {children}
      </View>
      {showSeparator && <Separator style={styles.separator} />}
    </Fragment>
  );
}

export default class Card extends Component<Props> {
  static Header = Header;

  render() {
    let { style, isVendor, ...otherProps } = this.props;
    return (
      <View
        style={[styles.root, isVendor && styles.vendorRoot, style]}
        {...otherProps}
      />
    );
  }
}
